import {isDefined, isString} from "~/lib/helpers/guards";

export function kebabCase(str:string):string {
  return str
    .match(/[A-Z]{2,}(?=[A-Z][a-z]+[0-9]*|\b)|[A-Z]?[a-z]+[0-9]*|[A-Z]|[0-9]+/g)
    .map(x => x.toLowerCase())
    .join('-');
}


export function className(params: Record<string, boolean>);
export function className(base: string, params?: Record<string, boolean>);
export function className(base: string | Record<string, boolean>, params?: Record<string, boolean>) {

  let output;

  if( isString(base)){
    output = base;
  } else {
    output = "";
    params = base;
  }

  if( isDefined(params)){
    let keys = Object.keys(params);
    for (let key of keys) {
      if (params[key] === true) {
        output += ` ${kebabCase(key)}`
      }
    }
  }

  return output;
}
